module.exports = __webpack_public_path__ + "static/media/edd.8d992bca.svg";